import { render } from "./WCItemGroupsMenu.vue?vue&type=template&id=1cc36188&scoped=true"
import script from "./WCItemGroupsMenu.vue?vue&type=script&lang=js"
export * from "./WCItemGroupsMenu.vue?vue&type=script&lang=js"

import "./WCItemGroupsMenu.vue?vue&type=style&index=0&id=1cc36188&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc36188"]])

export default __exports__